import { checkManagerTemplate, checkManager } from "./checkManager";
	import { getAccountAddressTemplate, getAccountAddress } from "./getAccountAddress";
	import { getBalanceTemplate, getBalance } from "./getBalance";
	import { getBlockOffsetTemplate, getBlockOffset } from "./getBlockOffset";
	import { getContractAddressTemplate, getContractAddress } from "./getContractAddress";
	import { getManagerAddressTemplate, getManagerAddress } from "./getManagerAddress";
	import { getTimestampOffsetTemplate, getTimestampOffset } from "./getTimestampOffset";
	export {
	  checkManagerTemplate,
	  checkManager,
	  getAccountAddressTemplate,
	  getAccountAddress,
	  getBalanceTemplate,
	  getBalance,
	  getBlockOffsetTemplate,
	  getBlockOffset,
	  getContractAddressTemplate,
	  getContractAddress,
	  getManagerAddressTemplate,
	  getManagerAddress,
	  getTimestampOffsetTemplate,
	  getTimestampOffset,
	};
	export default {
	  checkManagerTemplate,
	  checkManager,
	  getAccountAddressTemplate,
	  getAccountAddress,
	  getBalanceTemplate,
	  getBalance,
	  getBlockOffsetTemplate,
	  getBlockOffset,
	  getContractAddressTemplate,
	  getContractAddress,
	  getManagerAddressTemplate,
	  getManagerAddress,
	  getTimestampOffsetTemplate,
	  getTimestampOffset,
	};
	